"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.getDomainUrl = getDomainUrl;
exports.getFollowOrNoFollow = getFollowOrNoFollow;
exports.getSearchConfig = getSearchConfig;
exports.getPlainText = getPlainText;
exports.handleKeyPress = handleKeyPress;
exports.getEnvPrefix = getEnvPrefix;
exports.getHostName = getHostName;
exports.handleSpaceKeyPress = handleSpaceKeyPress;
exports.generateKey = generateKey;
exports.getLocalStorageCategoriesKey = getLocalStorageCategoriesKey;
exports.getLocalStorageSubcategoriesKey = getLocalStorageSubcategoriesKey;
exports.getLocalStorageEyeBrowKey = getLocalStorageEyeBrowKey;
exports.getLocalStorageDCSubnavConfigKey = getLocalStorageDCSubnavConfigKey;
exports.setDataToLocalStorage = setDataToLocalStorage;
exports.getDataFromLocalStorage = getDataFromLocalStorage;
exports.removeDataToLocalStorage = removeDataToLocalStorage;
exports.getSFLYHostNameBasedonBrand = getSFLYHostNameBasedonBrand;
exports.consoleLog = consoleLog;
exports.consoleWarn = consoleWarn;
exports.consoleInfo = consoleInfo;
exports.consoleDebug = consoleDebug;
exports.getQueryStringParameters = getQueryStringParameters;
exports.isAbsolutePath = isAbsolutePath;
exports.strEndsWith = strEndsWith;

require("core-js/modules/es6.regexp.search");

require("core-js/modules/es6.regexp.split");

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.object.to-string");

var _stringify = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/json/stringify"));

require("core-js/modules/es6.regexp.match");

require("core-js/modules/es6.regexp.replace");

var _uigCurrentEnvironmentUtil = require("@sfly/uig-current-environment-util");

var _constants = require("../../constants");
/*
 *  determine the domain
 */


function getDomainUrl(activeStore) {
  var domainUrl = (0, _uigCurrentEnvironmentUtil.getBaseHostname)();

  if (activeStore && activeStore !== '') {
    if (activeStore === _constants.BRANDS.TINYPRINTS) {
      domainUrl = domainUrl.replace('shutterfly.com', 'tinyprints.com');
    } else if (activeStore === _constants.BRANDS.SHUTTERFLY || activeStore === _constants.BRANDS.INC) {
      domainUrl = domainUrl.replace('tinyprints.com', 'shutterfly.com');
    }

    domainUrl = "https://www.".concat(domainUrl);
  }

  return domainUrl;
}
/*
 * get the rel string, it will either be 'follow' or 'nofollow'.
 * If the domain and the activeStore do not match, then it's 'nofollow', otherwise it's a 'follow'
 */


function getFollowOrNoFollow(activeStore) {
  if (activeStore === _constants.BRANDS.TINYPRINTS && typeof window !== 'undefined' && window.location.hostname.match(/shutterfly.com/)) {
    return 'nofollow';
  }

  if (activeStore === _constants.BRANDS.SHUTTERFLY && typeof window !== 'undefined' && window.location.hostname.match(/tinyprints.com/)) {
    return 'nofollow';
  }

  return 'follow';
}
/**
 * @description
 * Returns the API keys required by the search REST service call
 */


function getSearchConfig() {
  var config = {
    headers: {
      'SFLY-Apikey': (0, _uigCurrentEnvironmentUtil.getCurrentEnv)() !== 'production' ? 'qsKPGjhXADM2dRvIif8vWcCxEfU5ubX1' : 'cJFFkinUtsq0bj8fnRuFvuAW2L2sUl1Y'
    }
  };
  return config;
}
/**
 * @description
 * This takes a string with HTML tags like <sup> and returns a string that can be used by react to render it as text
 * Sample Input string `Make My Book<sup>&trade;</sup> Service`
 * Return value `Make My Book™ Service`
 * @param {String} htmlString
 * @returns {String}
 */


function getPlainText(htmlString) {
  if (typeof document === 'undefined') {
    return '';
  }

  var div = document.createElement('div');
  div.innerHTML = htmlString;
  return div.textContent || div.innerText || '';
} // prevents the default behaviour of and handles the 'Enter' key press


function handleKeyPress() {
  var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var cb = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};

  if (e.which === 13 || e.keyCode === 13) {
    e.preventDefault();
    cb(e);
  }
}

function getEnvPrefix() {
  var env = (0, _uigCurrentEnvironmentUtil.getCurrentEnv)();

  if (env === 'production') {
    return '';
  }

  return "".concat(env, ".");
}

function getHostName() {
  var brand = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _constants.BRANDS.SHUTTERFLY;

  if (brand === _constants.BRANDS.TINYPRINTS) {
    return "//wwww.".concat(getEnvPrefix(), "tinyprints.com");
  } else {
    return "//www.".concat(getEnvPrefix(), "shutterfly.com");
  }
}

function handleSpaceKeyPress() {
  var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var cb = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};

  if (e.which === 32 || e.charCode === 32) {
    e.preventDefault();
    cb(e);
  }
}

function generateKey() {
  var pre = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'key';
  return "".concat(pre, "_").concat(new Date().getTime());
}

function getLocalStorageCategoriesKey() {
  var brand = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'SFLY';
  return "".concat(brand, "-categories-data");
}

function getLocalStorageSubcategoriesKey() {
  var brand = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'SFLY';
  return "".concat(brand, "-subcategories-data");
}

function getLocalStorageEyeBrowKey() {
  var brand = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'SFLY';
  return "".concat(brand, "-eyebrow-data");
}

function getLocalStorageDCSubnavConfigKey() {
  var brand = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'SFLY';
  return "".concat(brand, "-dc-subnav-data");
}

function setDataToLocalStorage() {
  var key = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'cachedKey';
  var data = arguments.length > 1 ? arguments[1] : undefined;
  consoleLog('setting value to key : ', key);
  var object = {
    value: data,
    timestamp: new Date().getTime()
  };
  localStorage.setItem(key, (0, _stringify.default)(object));
}

function getDataFromLocalStorage() {
  var key = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'cachedKey';
  var invalidCachedTimeInMinute = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1; // 60000 millisecound = 1 min

  consoleLog('getting value from key : ', key);
  consoleLog('invalidCachedTimeInMinute : ', invalidCachedTimeInMinute);
  var object = JSON.parse(localStorage.getItem(key));

  if (object) {
    var dateString = object.timestamp;
    var now = new Date().getTime().toString();
    var timeDiff = now - dateString;
    consoleLog('timediff :', timeDiff);

    if (timeDiff < invalidCachedTimeInMinute * 60000) {
      // not valid cached
      consoleLog('valid cached : ', key);
      return object.value;
    }

    consoleLog('Invalid cached ', key);
  }

  consoleLog('data not found in cached : ', key);
  return null;
}

function removeDataToLocalStorage(key) {
  consoleLog('removed  :', key);
  localStorage.removeItem(key);
}

function getSFLYHostNameBasedonBrand(brand) {
  return brand === _constants.BRANDS.TINYPRINTS || brand === _constants.BRANDS.INC ? '' : "https://".concat(getHostName(_constants.BRANDS.SHUTTERFLY));
}

function consoleLog(msg) {
  var additionalData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var isForcePrint = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  if (isForcePrint || localStorage.getItem('enableConsoleLogging') === 'true') {
    console.log(msg, additionalData);
  }
}

function consoleWarn(msg) {
  var additionalData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var isForcePrint = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  if (isForcePrint || localStorage.getItem('enableConsoleLogging') === 'true') {
    console.warn(msg, additionalData);
  }
}

function consoleInfo(msg) {
  var additionalData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var isForcePrint = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  if (isForcePrint || localStorage.getItem('enableConsoleLogging') === 'true') {
    console.info(msg, additionalData);
  }
}

function consoleDebug(msg) {
  var additionalData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var isForcePrint = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  if (isForcePrint || localStorage.getItem('enableConsoleLogging') === 'true') {
    console.debug(msg, additionalData);
  }
}

function getQueryStringParameters() {
  var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

  var urlParams = {},
      match,
      additional = /\+/g,
      // Regex for replacing additional symbol with a space
  search = /([^&=]+)=?([^&]*)/g,
      decode = function decode(s) {
    return decodeURIComponent(s.replace(additional, ' '));
  },
      query;

  if (url) {
    if (url.split('?').length > 0) {
      query = url.split('?')[1];
    }
  } else {
    url = typeof window !== 'undefined' ? window.location.href : '';
    query = typeof window !== 'undefined' ? window.location.search.substring(1) : '';
  }

  while (match = search.exec(query)) {
    urlParams[decode(match[1])] = decode(match[2]);
  } // console.log(urlParams);


  return urlParams;
}

function isAbsolutePath(url) {
  return /^https?:\/\//i.test(url) || /^http?:\/\//i.test(url);
}

function strEndsWith(currentUrlPath, categoryName) {
  return categoryName === currentUrlPath.substr(0 - categoryName.length);
}